import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CreationDynamicComponentDataService } from './shared/creation-dynamic-component.data.service';
import { CreationDynamicComponentConfig } from './shared/creation-dynamic-component-config.service';
import { GlobalInfoService, Logger, AuthenticationService } from '@app/core';
import { LocalDataSource } from 'ng2-smart-table';
import { ViewChild, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { find } from 'lodash';
import { environment } from '@env/environment';
import { ToastrService } from 'ngx-toastr';
import {
  FormaTabla,
  VersionForma,
  SubForma,
  Forma,
  DuplicacionForma,
  Const
} from '@app/shared';
import { Subject } from 'rxjs';

const log = new Logger('CreationDynamicComponentComponent');

@Component({
  selector: 'iw-creation-dynamic-component',
  templateUrl: './creation-dynamic-component.component.html',
  styleUrls: ['./creation-dynamic-component.component.scss'],
  providers: [CreationDynamicComponentDataService]
})
export class CreationDynamicComponentComponent implements OnInit, OnDestroy {
  // Mensaje de guardar componente
  messaggeLoading = 'Procesando solicitud';
  // define si se creara un nuevo componente
  newComponent = true;
  // Define si muestra el componente de creacion de formulario
  openCreationForm = false;
  // Controla el evento de carga
  loadingProcess = false;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    delete: false,
    review: false,
    buildForms: false
  };
  // Para mostrar información de debug.
  debug: boolean = environment.showDebugHelpers;
  // Contiene las formas
  source: Array<FormaTabla> = [];
  // Contiene la forma seleccionada para ver
  versionsDuplicate: Array<VersionForma> = [];
  // Contiene la forma seleccionada para ver
  subFormsDuplicate: Array<SubForma> = [];
  // Acomula las formas consultadas
  acomulateForms: Array<{id_forma: number, form: Forma}> = [];
  // Configuracion de la tabla
  settings = {};
  // Mensajes de las validaciones de los campos
  messages = {
    alias: {
      pattern: 'El alias de la forma es obligatorio, solo permite letras y guiones bajos'
    }
  };
  // Contiene la forma seleccionada para ver
  formSelect: FormaTabla;
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Referencia de la modal
  modalRef: BsModalRef;
  // formulario de duplicar
  formDuplicate: FormGroup = new FormGroup({
    cboForm: new FormControl(null, [Validators.required]),
    cboVersion: new FormControl(null, [Validators.required]),
    cboFormulario: new FormControl(null, [Validators.required]),
    txtNombre: new FormControl(null, [Validators.required]),
    txtAlias: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z_]*$')]),
    txtDescription: new FormControl(null),
  });
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al template de la modal de duplicacion de forma
  @ViewChild('templateDuplicate') private templateDuplicate: TemplateRef<any>;

  constructor(
    private gis: GlobalInfoService,
    private cdcds: CreationDynamicComponentDataService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private as: AuthenticationService,
  ) { }

  ngOnInit() {
    // determina los permisos del usuario en sesion
    this.activateAction.buildForms = this.as.confirmPermission(
      Const.types_permissions.administrationForms,
      Const.types_action_permissions.buildForms,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationForms,
      Const.types_action_permissions.review,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationForms,
      Const.types_action_permissions.delete,
    );
    // se setea el titulo de la vista actual
    this.gis.set({ title: 'Administración de formas dinámicas' });
    // Se inicia la configuracion de la tabla
    const configTable = new CreationDynamicComponentConfig();
    this.settings = configTable.settings;
    configTable.accion.subscribe((data: any) => {
      // this.accionTable(data);
      if (this.activateAction.delete || this.activateAction.buildForms || this.activateAction.review) {
        this.loadingForm(data);
      } else {
        this.toastr.error('Usted no posee permisos para construir o eliminar las formas dinámicas', 'Permiso denegado');
      }
    });
    this.loadingForms();
    this.formDuplicate.controls['cboForm'].valueChanges.subscribe((data: Array<VersionForma>) => {
      log.debug(data);
      this.formDuplicate.controls['cboVersion'].setValue(null);
      if (data && data.length) {
        this.versionsDuplicate = data;
        this.versionsDuplicate.sort((a, b) => a.version - b.version);
      }
    });
    this.formDuplicate.controls['cboVersion'].valueChanges.subscribe((idForma: number) => {
      log.debug(idForma);
      if (idForma) {
        const formA = find(this.acomulateForms, {id_forma: idForma});
        if (!formA) {
          this.cdcds.getForm(idForma).subscribe(form => {
            this.subFormsDuplicate = form.sub_formas;
            this.acomulateForms.push({
              id_forma: form.id,
              form: form
            });
          });
        } else {
          this.subFormsDuplicate = formA.form.sub_formas;
        }
      } else {
        this.subFormsDuplicate = [];
        this.formDuplicate.controls['cboFormulario'].setValue(null);
      }
    });
  }
  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Carga los datos de las formas poara mostrar los registros en la tabla principal
   *
   * @memberof CreationDynamicComponentComponent
   */
  loadingForms() {
    this.source = [];
    this.cdcds.getFormsDynamics().subscribe(forms => {
      forms.forEach(form => {
        let version = 0;
        let versionForma: VersionForma;
        form.versiones.forEach(v => {
          if (v.version > version) {
            version = v.version;
            versionForma = {
              id: v.id,
              version: v.version,
              descripcion: v.descripcion
            };
          }
        });
        this.source.push({
          id: versionForma.id,
          nombre: form.nombre,
          descripcion: versionForma.descripcion,
          version: versionForma.version,
          versiones: form.versiones
        });
      });
      this.sourceData = new LocalDataSource(this.source);
      this.sourceData.refresh();
    });
  }

  /**
   * Cierra el componente de creacion de los componentes
   *
   * @param {boolean} data
   * @memberof CreationDynamicComponentComponent
   */
  close(data: boolean) {
    if (data) {
      this.openCreationForm  = false;
    }
  }

  /**
   * Carga el componente seleccionado
   *
   * @param {FormaTabla} rowSelect
   * @memberof CreationDynamicComponentComponent
   */
  loadingForm(rowSelect: FormaTabla) {
    this.formSelect = rowSelect;
    this.openCreationForm = true;
    this.newComponent = false;
  }

  /**
   * Abre el modal con el formulario de duplicacion
   *
   * @param {FormaTabla} data
   * @memberof CreationDynamicComponentComponent
   */
  openModalDuplicate() {
    this.modalRef = this.modalService.show(this.templateDuplicate, { class: 'modal-lg'});
  }

  /**
   * Abre el modal con el formulario de duplicacion
   *
   * @memberof CreationDynamicComponentComponent
   */
  closeModalDuplicate() {
    this.formSelect = null;
    this.versionsDuplicate = [];
    this.subFormsDuplicate = [];
    this.formDuplicate.reset();
    this.modalRef.hide();
  }

  /**
   * Contrala el envio del formulario para duplicar la forma
   *
   * @memberof CreationDynamicComponentComponent
   */
  duplicateForm() {
    if (this.formDuplicate.valid) {
      const data: any = this.formDuplicate.value;
      this.loadingProcess = true;
      if (data) {
        const formDuplicate: DuplicacionForma = {
          subformas_ids: data.cboFormulario,
          forma_destino_data: {
            origen_id: data.cboVersion,
            nombre: data.txtNombre,
            alias: data.txtAlias,
            descripcion: data.txtDescription,
          }
        };
        this.messaggeLoading = 'Duplicando forma';
        const resp = this.cdcds.duplicateForm(formDuplicate).then(() => {
          this.loadingProcess = false;
          this.messaggeLoading = 'Procesando solicitud';
          if (resp) {
            this.loadingForms();
            this.closeModalDuplicate();
          }
        }).catch(() => {
          this.loadingProcess = false;
          this.messaggeLoading = 'Procesando solicitud';
        });
      }
    } else {
      this.toastr.error('Debe ingresar todos los campos requeridos para realizar la acción.', 'Información incompleta');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-dynamic-component.component.ts